<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-w-100pct cmps-cdk-h-100pct cmps-report-bg-color-ukn-103"
>
    <div
        class="cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-h-55px cmps-cdk-min-h-55p cmps-uik-box-shadow-200"
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-80 cmps-cdk-p-0dot5 cmps-cdk-cg-0dot5"
        >
            <div
                class="cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-d-flex cmps-cdk-flex-grow-1"
            >
                <div class="cmps-cdk-font-bold cmps-cdk-font-size-18p">
                    Reports
                </div>
            </div>
        </div>
    </div>

    <div
        class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-flex-grow-1 cmps-cdk-overflow-y-auto"
    >
        <div
            class="cmps-cdk-flex-80 cmps-cdk-px-0dot5 cmps-cdk-py-1 cmps-cdk-h-fit"
        >
            <div
                class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-h-100pct cmps-cdk-overflow-y-auto"
            >
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-h-45px cmps-cdk-min-h-45p cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-300 cmps-cdk-font-bold cmps-cdk-bg-color-white cmps-cdk-pos-sticky cmps-cdk-pos-top-0"
                >
                    <div class="cmps-cdk-flex-60 cmps-cdk-p-0dot25">
                        <span class="cmps-cdk-line-clamp-2"
                            >Name / Parameters</span
                        >
                    </div>
                    <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot25">
                        <span class="cmps-cdk-line-clamp-2">Status</span>
                    </div>
                    <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot25">
                        <span class="cmps-cdk-line-clamp-2">Actions</span>
                    </div>
                </div>
                <div
                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-h-45px cmps-cdk-min-h-45p"
                    [class.cmps-cdk-border-b-width-1p]="!l"
                    [class.cmps-cdk-border-b-solid]="!l"
                    [class.cmps-cdk-border-b-color-grey-300]="!l"
                    *ngFor="let b of rows; let l = last"
                >
                    <div class="cmps-cdk-flex-60 cmps-cdk-p-0dot25">
                        <span class="cmps-cdk-line-clamp-2">{{ b.name }}</span>
                    </div>
                    <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot25">
                        <span class="cmps-cdk-line-clamp-2">{{
                            b.status
                        }}</span>
                    </div>
                    <div class="cmps-cdk-flex-20 cmps-cdk-p-0dot25">
                        <div>
                            <button
                                type="button"
                                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-h-34px cmps-cdk-w-34px"
                                [routerLink]="b.link"
                                [cmpsTooltipTrigger]="'View'"
                            >
                                <cmps-icon svgIcon="form-select"></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
